/* @flow */

import React, { PureComponent } from 'react'
import type { ChildrenArray, Node } from 'react'
import Button from './button'
import i18n from '../helpers/i18n'
import type CancelablePromise from '../cancelable_promise'

type NavigationButtonsPropsType = {
  previousAction?: (any) => CancelablePromise,
  previousLabel?: string,
  previousProps?: Object,
  nextAction?: (any) => CancelablePromise,
  nextLabel?: string,
  nextProps?: Object,
  disabled?: boolean,
  loading?: boolean,
  tabIndex?: number,
  className?: string,
  order: Array<string>,
  wrapperClassName?: string,
  children?: ChildrenArray<Node> | Node,
  arrow?: boolean
}

type NavigationButtonsStateType = {
  disabled: boolean,
  loading: boolean
}

class NavigationButtons extends PureComponent<NavigationButtonsPropsType, NavigationButtonsStateType> {
  _action: ?CancelablePromise

  static defaultProps = {
    disabled: false,
    loading: false,
    order: ['next', 'previous'],
    wrapperClassName: 'atp-buttons',
    arrow: true,
    tabIndex: 0
  }

  state = {
    disabled: false,
    loading: false
  }

  reset = () => {
    if (this._action && !this._action._canceled) {
      this.setState({
        disabled: false,
        loading: false
      })
    }
    this._action = undefined
  }

  clickHandler(action: ?() => CancelablePromise) {
    if (this.state.disabled || !action) return
    this.setState({
      disabled: true,
      loading: true
    })
    if (this._action) this._action.cancel()
    if (action) this._action = action()
    if (this._action && typeof this._action.finally == 'function') {
      this._action.finally(this.reset)
    }
  }

  clickHandlerNext = () => {
    const { nextAction } = this.props
    this.clickHandler(nextAction)
  }

  clickHandlerPrevious = () => {
    const { previousAction } = this.props
    this.clickHandler(previousAction)
  }

  componentWillUnmount() {
    if (this._action) this._action.cancel()
  }

  buttonNext() {
    const { arrow, tabIndex, nextAction, nextLabel, nextProps = {} } = this.props
    if (nextAction) {
      return (
        <Button
          {...nextProps}
          key="next"
          type="submit"
          action={this.clickHandlerNext}
          disabled={this.state.disabled || this.props.disabled}
          loading={this.state.loading || this.props.loading}
          tabIndex={tabIndex}
          arrow={arrow}>
          {nextLabel || i18n.trans(['buttons', 'next'])}
        </Button>
      )
    }
    return null
  }

  buttonPrevious() {
    const { arrow, tabIndex, previousAction, previousLabel, previousProps = {} } = this.props
    if (previousAction) {
      return (
        <Button
          {...previousProps}
          key="previous"
          type="button"
          className={previousProps.className || 'atp-btn--icon-only'}
          action={this.clickHandlerPrevious}
          disabled={this.state.disabled || this.props.disabled}
          tabIndex={tabIndex}
          arrow={arrow}>
          {previousLabel || i18n.trans(['buttons', 'previous'])}
        </Button>
      )
    }
    return null
  }

  buttons() {
    const { order } = this.props
    // $FlowFixMe
    return order.map((name) => {
      if (name == 'next') return this.buttonNext()
      else if (name == 'previous') return this.buttonPrevious()
    })
  }

  render() {
    const { wrapperClassName, children } = this.props
    return (
      <div className={wrapperClassName}>
        {this.buttons()}
        {children}
      </div>
    )
  }
}

export default NavigationButtons
